import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable
} from "@angular/material/table";
import {StockService} from "../../services/api/stocks/stock.service";
import {StockCreateRequest, StockResponse} from "../../services/api/stocks/model";
import {MatTableModule} from "@angular/material/table";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {HeadComponent} from "../../components/head/head.component";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";
import {PopinComponent} from "../../components/popin/popin.component";
import {ItemResponse} from "../../services/api/item/model";
import {ItemService} from "../../services/api/item/item.service";
import {StocksDetailsPageComponent} from "./stocks-details-page/stocks-details-page.component";
import {StocksGeneralPageComponent} from "./stocks-general-page/stocks-general-page.component";
import {format_price} from "../../utils/helper";


@Component({
  selector: 'app-stocks-page',
  standalone: true,
  imports: [
    MatCell,
    MatTableModule,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatTabGroup,
    MatTab,
    HeadComponent,
    NgClass,
    MatButton,
    NgForOf,
    FormsModule,
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    PopinComponent,
    NgIf,
    StocksDetailsPageComponent,
    StocksGeneralPageComponent
  ],
  templateUrl: './stocks-page.component.html',
  styleUrl: './stocks-page.component.css'
})
export class StocksPageComponent implements OnInit {
  selectedStockPage = 'general';
  selectedItem: StockResponse | undefined;
  itemList: ItemResponse[] = []
  isPopinOpen = false;
  createPopin = false;
  popinTitle = "";
  itemQuantity: number = 0;
  itemExpirationDate = "";
  itemProductionDate = "";
  itemTresholdDays: number = 0;
  isAddingStock: boolean = false;
  showDropdown = true;
  newItemId: number | undefined
  locationId: number = 1;
  errorMessage = '';
  searchTerm: string = '';
  filteredItems: ItemResponse[] = [];
  triggerRefresh = false;

  constructor(
    private stockService: StockService,
    private itemService: ItemService,
  ) {
  }

  ngOnInit() {
    this.getItems();
  }

  getItems() {
    this.itemService.getItems().subscribe(res => {
      this.itemList = res;
    })
  }

  selectPage(choice: string) {
    this.selectedStockPage = choice;
  }

  openPopin(transactionType: string, item: StockResponse) {
    this.triggerRefresh = !this.triggerRefresh;
    this.selectedItem = item;
    this.isPopinOpen = true;
    if (transactionType === "add") {
      this.popinTitle = "Ajouter du";
      this.isAddingStock = true;
    } else {
      this.popinTitle = "Retirer du "
      this.isAddingStock = false;
    }
  }

  formatDateToMMDDYYYY(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  closePopin() {
    this.isPopinOpen = false;
    this.createPopin = false;
    this.itemQuantity = 0;
    this.searchTerm = '';
    this.errorMessage = '';
    this.triggerRefresh = !this.triggerRefresh;
    this.newItemId = undefined;
  }

  addStock() {
    if (this.selectedItem) {
      this.addTransaction(
        this.selectedItem.item_id,
        this.itemQuantity,
        this.selectedItem.location_id,
        "add",
        this.selectedItem.expiration_date,
        this.selectedItem.production_date,
        this.selectedItem.threshold_days,
      )
    }
  }

  retireStock() {
    if (this.selectedItem && (this.selectedItem.actual_quantity >= this.itemQuantity)) {
      this.addTransaction(
        this.selectedItem.item_id,
        this.itemQuantity,
        this.selectedItem.location_id,
        "remove",
        this.selectedItem.expiration_date,
        this.selectedItem.production_date,
        this.selectedItem.threshold_days)
    } else {
      this.errorMessage = "Stock insuffisant";
    }
  }

  addTransaction(itemId: number,
                 quantity: number,
                 locationId: number,
                 type: string,
                 expirationDate: string,
                 productionDate: string,
                 tresholdDays: number,
  ) {
    const body: StockCreateRequest = {
      item_id: itemId,
      actual_quantity: quantity,
      location_id: locationId,
      expiration_date: expirationDate,
      production_date: productionDate,
      threshold_days: tresholdDays,
      type: type,
    }
    this.stockService.addStockTransaction(body).subscribe(res => {
        this.closePopin();
      }
    )
  }

  filterItems() {
    const query = this.searchTerm.toLowerCase();

    if (query) {
      this.filteredItems = this.itemList.filter(item => item.name.toLowerCase().includes(query));
    } else {
      this.filteredItems = [];
    }
  }

  hideDropdown() {
    setTimeout(() => {
      this.showDropdown = false;
    }, 200); // Delay to allow selection before hiding
  }

  selectItem(item: ItemResponse) {
    this.searchTerm = item.name;
    this.newItemId = item.id;
    this.filteredItems = [];
    this.showDropdown = false;
  }

  checkValidItem(): boolean {
    let validateForm = true;
    if (!this.newItemId ||
      this.itemQuantity === 0 ||
      !this.itemExpirationDate ||
      !this.itemProductionDate ||
      !this.itemTresholdDays
    ) {
      validateForm = false;
    }
    return validateForm;
  }

  newStock() {
    if (this.checkValidItem()) {
      if (this.newItemId) {
        this.addTransaction(
          this.newItemId,
          this.itemQuantity,
          this.locationId,
          "add",
          this.itemExpirationDate,
          this.itemProductionDate,
          this.itemTresholdDays
        );
        this.closePopin();
      }
    } else {
      this.errorMessage = 'Complétez bien tous les champs';
    }

  }

  protected readonly format_price = format_price;
}
